
export const lastCharacterOfString = (input?: string): string|undefined =>
  input?.slice(-1);
